import { render, staticRenderFns } from "./AddPerintah.vue?vue&type=template&id=26ea88a8&scoped=true&"
import script from "./AddPerintah.vue?vue&type=script&lang=js&"
export * from "./AddPerintah.vue?vue&type=script&lang=js&"
import style0 from "./AddPerintah.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddPerintah.vue?vue&type=style&index=1&id=26ea88a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ea88a8",
  null
  
)

export default component.exports